import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const index = () => {
  return (
    <Wrapper>
      <div className="regular-box">
        <div className="discount">-10%</div>
        <div className="plan">Basic</div>
        <div className="price-area">
          <div className="price">
            <sup className="money">$</sup>3000
          </div>
          <div className="permont">Per month</div>
        </div>
        <p className="hours">
          <b>40 hours</b> a month
        </p>
        <p className="hours">
          +1hour <b>$75</b>
        </p>
        <Link to="#" className="btn">
          GET STARTED
        </Link>
      </div>

      <div className="recommend-box">
        <div className="discount">-10%</div>
        <div className="plan">Standart</div>
        <div className="price-area">
          <div className="price">
            <sup className="money">$</sup>5600
          </div>
          <div className="permont">Per month</div>
        </div>
        <p className="hours">
          <b>80 hours</b> a month
        </p>
        <p className="hours">
          +1hour <b>$70</b>
        </p>
        <Link to="#" className="btn btn-main">
          GET STARTED
        </Link>
      </div>

      <div className="regular-box">
        <div className="discount">-10%</div>
        <div className="plan">Premium</div>
        <div className="price-area">
          <div className="price">
            <sup className="money">$</sup>9600
          </div>
          <div className="permont">Per month</div>
        </div>
        <p className="hours">
          <b>160 hours</b> a month
        </p>
        <p className="hours">
          +1hour <b>$60</b>
        </p>
        <Link to="#" className="btn">
          GET STARTED
        </Link>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .regular-box {
    position: relative;
    background-color: var(--clr-white);
    color: var(--clr-primary-1);
    border: 1px solid var(--clr-grey-9);
    margin: 0 36px 80px;
    position: relative;
    text-align: center;

    .discount {
      position: absolute;
      top: 0;
      right: 0;
      color: var(--clr-white);
      background-color: var(--clr-primary-1);
      font-weight: bold;
      font-size: 12px;
      line-height: 190%;
      padding: 0 25px;
    }
    .plan {
      font-size: 16px;
      line-height: 190%;
      text-align: center;
      margin-top: 33px;
    }
    .price-area {
      margin-top: 35px;
      text-align: center;
    }
    .money {
      font-size: 24px;
      line-height: 36px;
      vertical-align: baseline;
      position: relative;
      top: -2em;
    }
    .price {
      font-weight: 500;
      font-size: 64px;
      line-height: 96px;
    }
    .permont {
      color: var(--clr-grey-8);
      margin-top: -20px;
      margin-bottom: 30px;
    }

    .btn {
      border: 1px solid var(--clr-primary-2);
      color: var(--clr-primary-2);
      padding: 15px 30px;
      margin-top: 30px;
      margin-bottom: 39px;
    }
  }

  .recommend-box {
    position: relative;
    background-color: var(--clr-primary-1);
    color: var(--clr-white);
    border: 1px solid var(--clr-grey-9);
    margin: 0 10px 80px;
    position: relative;
    text-align: center;

    .discount {
      position: absolute;
      top: 0;
      right: 0;
      color: var(--clr-primary-1);
      background-color: var(--clr-white);
      font-weight: bold;
      font-size: 12px;
      line-height: 190%;
      padding: 0 25px;
    }
    .plan {
      font-size: 16px;
      line-height: 190%;
      text-align: center;
      margin-top: 33px;
    }
    .price-area {
      margin-top: 35px;
      text-align: center;
    }
    .money {
      font-size: 24px;
      line-height: 36px;
      vertical-align: baseline;
      position: relative;
      top: -2em;
    }
    .price {
      font-weight: 500;
      font-size: 64px;
      line-height: 96px;
    }
    .permont {
      color: var(--clr-grey-9);
      margin-top: -20px;
      margin-bottom: 30px;
    }
    p {color: var(--clr-white);}

  }
`
export default index
